const genratePlanCheck= {
    ALLOWED:1 ,
    NOT_ALLOWED:0
}

const preferencesCheck= {
    ALLOWED:1 ,
    NOT_ALLOWED:0
}

const formFieldCheck = {
    ALLOWED:1 ,
    NOT_ALLOWED:0
}
const isPendingMeal = {
    ALLOWED:1 ,
    NOT_ALLOWED:0
}

module.exports ={
    genratePlanCheck,
    preferencesCheck,
    formFieldCheck,
    isPendingMeal
}